module.exports = __webpack_public_path__ + "40347ab49b354c72cd8591fc466b5790.png";